export default [
  {
    title: "الرئيسية",
    icon: "HomeIcon",
    route: "dashboard-home",
    tagVariant: 'light-warning',
  },
]
